import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { ensureExists } from '~/utils'

import { pathKey } from '../utils'

export const useBrandAccountId = () => {
  const { t } = useTranslation()
  const { brandAccountId } = usePathParams(pathKey)

  return ensureExists(brandAccountId, t('assertion_failed'))
}
